import { ComplianceEventType, VettingEvent, VettingStatus, YesNo } from '@percent/admin-dashboard/api/types'

const baseVettingEventResult = {
  createdAt: '2024-01-24T08:41:59.239Z',
  complyAdvantageSearchId: '1706086462-HYYvRshf'
}

export const mockValidComplyAdvantageVettingEventResult = {
  results: {
    sanction: {
      status: VettingStatus.PASS
    },
    warning: {
      status: VettingStatus.PENDING_REVIEW
    },
    adverseMedia: {
      status: VettingStatus.PASS
    },
    controversial: {
      status: VettingStatus.PENDING_REVIEW
    },
    commercial: {
      status: VettingStatus.PENDING_REVIEW
    },
    hateSpeech: {
      status: VettingStatus.PENDING_REVIEW
    }
  },
  ...baseVettingEventResult
}

export const mockVettingEventsHistory: VettingEvent[] = [
  {
    id: 'staging_vettingevent_000000CosficRZq99Zdi1AQh05mkb',
    organisationId: 'staging_organisation_000000CosfhOxgaUGaVD0QuGsRiS2',
    scope: 'adverseMedia' as ComplianceEventType,
    result: {
      status: YesNo.NO
    },
    expiresAt: '2025-03-28T11:15:03.207Z',
    createdBy: 'staging_account_000000Cg8miv2Ng7pbmmqOWFrVpa4',
    createdAt: '2024-03-28T11:15:02.600Z',
    deletedAt: null,
    status: VettingStatus.PASS,
    account: {
      id: 'staging_account_000000Cg8miv2Ng7pbmmqOWFrVpa4',
      fullName: 'John Doe',
      email: 'autoadmin_88@ijggjueo.mailosaur.net'
    }
  },
  {
    id: 'staging_vettingevent_000000CosficRZq99Zdi1AQh05mka',
    organisationId: 'staging_organisation_000000CosfhOxgaUGaVD0QuGsRiS2',
    scope: 'hateSpeech' as ComplianceEventType,
    result: {
      status: YesNo.NO
    },
    expiresAt: '2025-03-28T11:15:03.008Z',
    createdBy: 'staging_account_000000Cg8miv2Ng7pbmmqOWFrVpa4',
    createdAt: '2024-03-28T11:15:02.600Z',
    deletedAt: null,
    status: VettingStatus.PASS,
    account: {
      id: 'staging_account_000000Cg8miv2Ng7pbmmqOWFrVpa4',
      fullName: null,
      email: 'autoadmin_88@ijggjueo.mailosaur.net'
    }
  },
  {
    id: 'staging_vettingevent_000000CosfiVa7hKCOTYX4bOG7UAL',
    organisationId: 'staging_organisation_000000CosfhOxgaUGaVD0QuGsRiS2',
    scope: 'sanction' as ComplianceEventType,
    result: {
      status: YesNo.NO
    },
    expiresAt: '2025-03-28T11:15:02.825Z',
    createdBy: null,
    createdAt: '2024-03-28T11:15:02.600Z',
    deletedAt: null,
    status: VettingStatus.PASS,
    account: null
  }
]
